var exports = {
  "x": "PremiumUserBadge.module__button___Z0V6Zl",
};

module.exports = exports;
